// scheduledLdt is T2 (always date + time) and the expert's calendar needs a concrete hour,
// so a deadline picked as a date only is sent at this fixed time.
const DEFAULT_STEP_HOUR = 9;

export const withDefaultTime = (date: Date): Date => {
  const d = new Date(date);
  d.setHours(DEFAULT_STEP_HOUR, 0, 0, 0);
  return d;
};
